import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import { RACKLEY_BLUE, UI_BORDER_LIGHT_COLOR_NAME } from "styles/color-consts";
import colors from "styles/colors";
import { TOP_LAYER } from "constants/z-index";
const CARD_BACKGROUND_COLOR = "#343751";
export const StyledSelectableProductCard = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  cursor: pointer;
  width: 412px;
  height: fit-content;
  background-color: ${CARD_BACKGROUND_COLOR};
  margin: 0 20px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;

  &.card-animation {
    animation: breatheOut 0.3s linear;
  }

  .card-tag {
    .selectable-tag-wrapper {
      z-index: ${TOP_LAYER};
      background-color: ${colors[RACKLEY_BLUE]};
      padding: 12px 16px;
      border-radius: 90px;
      position: absolute;
      top: 16px;
      left: 16px;

      &.dark-mode:hover {
        background-color: ${colors[RACKLEY_BLUE]};
        opacity: 0.85;
      }

      .selectable-tag-image-container {
        border-radius: 4px;
      }

      &:not(.selected) {
        .selectable-tag-image-container {
          background-color: transparent;
          border-color: white;

          .selectable-tag-image {
            display: none;
          }
        }
      }

      .tag-text {
        color: white;
        font-size: 1rem;
        ${({ isSelectable })=>!isSelectable && "margin-left: 0;"}
      }
    }
  }

  .picture-wrapper {
    display: flex;
    justify-content: center;
    padding: 4px;

    .picture-component {
      display: flex;

      img {
        border-radius: 8px;
        width: 100%;
      }
    }
  }

  .card-content {
    position: absolute;
    bottom: -60%;
    width: 100%;
    padding: 20px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: ${CARD_BACKGROUND_COLOR};

    .title-wrapper {
      margin: 20px 0 20px 20px;
    }

    .use-cases-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      padding: 20px 0;

      .use-case {
        display: flex;
        gap: 4px;
        align-items: center;
        font-size: 0.875rem;
        color: ${colors[UI_BORDER_LIGHT_COLOR_NAME]};
      }
    }

    .product-logo-wrapper {
      .picture-component {
        display: flex;

        img {
          height: 32px;
        }
      }
    }

    .product-signup-wrapper {
      display: flex;
    }

    &.up {
      animation: slide-up 0.75s ease-in-out forwards;
    }

    &.down {
      animation: slide-down 0.75s ease-in-out forwards;
    }
  }

  @media (max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px) {
    margin: 0 8px;
    width: 370px;

    .card-content {
      .title-wrapper {
        margin: 12px 0 12px 20px;
      }

      .use-cases-wrapper {
        .use-case {
          font-size: 0.75rem;
        }
      }
    }
  }

  @keyframes slide-up {
    0% {
      bottom: -60%;
    }
    100% {
      bottom: 0;
    }
  }

  @keyframes slide-down {
    0% {
      bottom: 0;
    }
    100% {
      bottom: -60%;
    }
  }

  @keyframes breatheOut {
    0% {
      transform: scale(1);
    }

    15% {
      transform: scale(1.01);
    }

    20% {
      transform: scale(1.02);
    }

    25% {
      transform: scale(1.03);
    }

    32% {
      transform: scale(1.04);
    }

    50% {
      transform: scale(1.05);
    }

    68% {
      transform: scale(1.04);
    }

    75% {
      transform: scale(1.03);
    }

    80% {
      transform: scale(1.02);
    }

    85% {
      transform: scale(1.01);
    }

    100% {
      transform: scale(1);
    }
  }
`;
